<template>
  <v-card class="pa-5 author-v-card">
    <v-container>
      <v-layout wrap row class="mb-4">
        <v-flex xs8>
          <h2 class="mb-4">TEOFILO O.L. SAN LUIS, JR., MD</h2>
        </v-flex>
      </v-layout>
      <v-layout wrap row>
        <v-flex xs12 md4>
          <img :src="author" width="300" class="image-author" />
        </v-flex>
        <v-flex xs12 md8>
          <div>
            <p class="subheading">
              <i class="purple--text"
                >National Coordinator Iodine Global Network (IGN) &mdash;
                Philippines.</i
              >
            </p>
            <p class="subheading">
              Dr. Teofilo O.L. San Luis Jr. obtained his degree of Doctor of
              Medicine at the University of Santo Tomas (UST) Faculty of
              Medicine and Surgery. He subsequently had his fellowship training
              in Nuclear Medicine, Institute for Clinical & Experimental Nuclear
              Medicine at University of Bonn, Germany. Subsequently, he had his
              research fellowship on Thyroidology at Klinikum Steglitz in
              Germany and on Autoimmune Thyroid Diseases at Gifu University in
              Japan. He is a graduate of Master of Arts in Public Administration
              at UST and took a course on Managing Health Programs in Developing
              Countries, at Harvard University School of Public Health in
              Boston, USA.
            </p>
            <p class="subheading">
              He is a former Professor of UST Faculty of Medicine & Surgery,
              former Dean of St. Luke’s College of Medicine – William H. Quasha
              Memorial and former Dean of Asian School of Nuclear Medicine.
            </p>
            <p class="subheading">
              He is a Past President of the Philippine Thyroid Association
              (PTA), Examiner of Asian Nuclear Medicine Board , Asian
              Cooperative Council for Nuclear Medicine (ARCCNM) and Course
              Director for various International Atomic Energy Agency (IAEA)
              Regional & National Training Course in Oncology, Thyroidology,
              Cardiology, Neurology & related Specialties and on Quality
              Management (QUANUM), held in Costa Rica, Morocco, Tanzania, Iran &
              the Philippines. In the Asia-Oceania Thyroid Association (AOTA) he
              served as Secretary (2010-2015) then Vice President (2015-2021).
            </p>
            <p class="subheading">
              He is the National Coordinator for the Philippines of the Iodine
              Global Network (IGN); an active member of ThyroWorld Editorial
              Board of Thyroid Federation International (TFI), member of the
              Technical Working Group of National Salt Iodization Program of
              Department of Health (DOH) National Nutrition Council and member
              of Technical Working Group of DOH Thyroid Disease Prevention &
              Control Program. He also holds a post as National Project
              Coordinator of Philippine Nuclear Research Institute (PNRI)
              PHI6025 Project. He is an active Faculty in the Department of
              Professionalism, Medical Ethics & Humanities of the St Luke's
              Medical Center College of Medicine - William H Quasha Memorial.
            </p>
            <!-- <p class="subheading">
              Currently, he is the Vice President of Asia &amp; Oceania Thyroid Association (AOTA), an active member of ThyroWorld Editorial Board of Thyroid Federation International (TFI), member of the Technical Working Group of National Salt Iodization Program of Department of Health (DOH) National Nutrition Council and member of Technical Working Group of DOH Thyroid Disease Prevention &amp; Control Program. He also holds a post as National Project Coordinator of Philippine Nuclear Research Institute (PNRI) PHI6025 Project.
            </p> -->
          </div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-spacer></v-spacer>
        <v-flex xs4 text-md-right>
          <v-btn large class="accent" to="/dashboard"> Back </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      author: require("../../../static/img/teofilo-san-luis-jr.jpg"),
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/author/teofilo.vue